import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-app-route',
  templateUrl: './app-route.component.html',
  styleUrls: ['./app-route.component.scss']
})
export class AppRouteComponent implements OnInit {
  app_route_id: number;
  @Input() item_id: number;
  

  constructor(public route: ActivatedRoute) { 
    this.app_route_id = +this.route.snapshot.paramMap.get('app_route_id');
  }

  ngOnInit(): void {
  }

}
